<template>
  <div>
    <div class="header" :class="{ 'header-fixed': !isTop }">
      <div class="header-logo">
        <img
          src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/25/logo@2x (1)-183933328.png"
          alt=""
        />

        <div class="header-nav">
          <div
            v-for="nav in navs"
            :key="nav.path"
            class="header-nav-item"
            @click="$router.push(nav.path)"
          >
            <span style="height: 100%">{{ nav.label }}</span>
            <i class="el-icon-arrow-down" v-if="nav.children"></i>
            <div
              class="header-nav-item-children"
              v-if="nav.label === '产品介绍'"
            >
              <div class="header-nav-item-box" style="width: 384px">
                <div
                  v-for="item in nav.children"
                  :key="item.path"
                  class="header-nav-item-box-item center"
                  @click.stop="$router.push(item.path)"
                >
                  <img :src="item.icon" alt="" />
                  <span>{{ item.label }}</span>
                </div>
              </div>
            </div>
            <div
              class="header-nav-item-children"
              v-if="nav.label === '解决方案'"
            >
              <div
                class="header-nav-item-box"
                style="padding: 26px 36px; flex-direction: column; width: 556px"
                @click.stop
              >
                <div class="nav-header">
                  <div
                    class="nav-header-item"
                    v-for="item in nav.children"
                    :key="item.label"
                    :class="{ active: item.label === activeNav }"
                    @click="activeNav = item.label"
                  >
                    {{ item.label }}
                  </div>
                </div>
                <div class="nav-content">
                  <div
                    class="nav-content-item center"
                    v-for="(item, index) in navContent"
                    :key="index"
                    :style="{ visibility: item.icon ? 'visible' : 'hidden' }"
                  >
                    <img :src="item.icon" alt="" />
                    <span>{{ item.label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="header-btn">
        <div
          class="header-btn-item"
          v-if="user"
          @click="$router.push('/workbench')"
        >
          进入工作台
        </div>
        <el-dropdown>
          <div class="center" style="cursor: pointer">
            <div
              style="
                width: 32px;
                height: 32px;
                background: #bfdbff;
                border-radius: 8px;
                margin-left: 14px;
              "
              class="center"
            >
              <img
                src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/28/人@2x-164015147.png"
                alt=""
                style="width: 16px; height: 16px"
              />
            </div>

            <div
              style="
                margin-left: 10px;
                margin-right: 8px;
                font-size: 14px;
                color: #3d3d3d;
                line-height: 18px;
              "
            >
              {{ user.name }}
            </div>

            <img
              src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/28/下拉@2x (2)-164221949.png"
              alt=""
              style="width: 14px; height: 14px"
            />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              @click.native="$store.dispatch('user/logOut')"
              v-if="!isDD"
              >退出登录</el-dropdown-item
            >
            <el-dropdown-item @click.native="browserOpen" v-if="isDD"
              >在浏览器中打开</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <div
          class="header-btn-item login"
          @click="$router.push('/login')"
          v-if="!user.id"
        >
          登录
        </div>
        <div class="header-btn-item" v-if="!user.id" @click="$router.push('/')">
          免费试用
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as dd from "dingtalk-jsapi";
export default {
  name: "SiteHeader",
  data() {
    return {
      isTop: true,
      navs: [
        {
          label: "首页",
          path: "/site",
        },
        {
          label: "模板中心",
          path: "/site/template",
        },
        {
          label: "产品介绍",
          path: "/site/product",
          children: [
            {
              label: "在线表单",
              path: "/site/product?type=1",
              icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/在线表单@2x-115131677.png",
            },
            {
              label: "业务流程",
              path: "/site/product?type=2",
              icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/业务流程@2x-115131676.png",
            },
            {
              label: "统计报表",
              path: "/site/product?type=3",
              icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/统计报表@2x-115131671.png",
            },
          ],
        },
        {
          label: "解决方案",
          path: "/site/scheme",
          children: [
            {
              label: "场景方案",
              children: [
                {
                  label: "CRM/销售",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/CRM／销售@2x-160227433.png",
                  path: "",
                },
                {
                  label: "ERP/生产",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/ERP／生产@2x-160227423.png",
                  path: "",
                },
                {
                  label: "进销存/仓库",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/进销存／仓库@2x-160227423.png",
                  path: "",
                },
                {
                  label: "人事/行政",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/人事／行政@2x-160227420.png",
                  path: "",
                },
                {
                  label: "项目/任务",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/项目／任务@2x-160227433.png",
                  path: "",
                },
                {
                  label: "财务/报销",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/财务／报销@2x-160227413.png",
                  path: "",
                },
                {
                  label: "工单/售后",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/工单／售后@2x-160227411.png",
                  path: "",
                },
                {
                  label: "采招/供应",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/采招／供应@2x-160227411.png",
                  path: "",
                },
                {},
              ],
            },
            {
              label: "行业方案",
              children: [
                {
                  label: "制造业",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/制造业@2x-160607110.png",
                  path: "",
                },
                {
                  label: "金融业",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/金融业@2x-160607103.png",
                  path: "",
                },
                {
                  label: "贸易零售",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/贸易零售@2x-160607124.png",
                  path: "",
                },
                {
                  label: "建筑工程",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/建筑工程@2x-160607145.png",
                  path: "",
                },
                {
                  label: "医疗健康",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/医疗健康@2x-160607151.png",
                  path: "",
                },
                {
                  label: "物流运输",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/物流运输@2x-160607138.png",
                  path: "",
                },
                {
                  label: "能源矿产",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/能源矿产@2x-160607143.png",
                  path: "",
                },
                {
                  label: "教育培训",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/教育培训@2x-160607153.png",
                  path: "",
                },
                {
                  label: "地产物业",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/地产物业@2x-160607117.png",
                  path: "",
                },
                {
                  label: "政府单位",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/政府单位@2x-160607095.png",
                  path: "",
                },
                {
                  label: "互联网科技",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/互联网科技@2x-160607134.png",
                  path: "",
                },
                {
                  label: "其他行业",
                  icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/其他@2x-160607131.png",
                  path: "",
                },
              ],
            },
          ],
        },
      ],
      activeNav: "场景方案",
    };
  },
  computed: {
    navContent() {
      return (
        this.navs[3].children.find((item) => item.label === this.activeNav)
          ?.children || []
      );
    },

    user() {
      console.log(this.$store.getters.userInfo);
      return this.$store.getters.userInfo;
    },
    isDD() {
      return dd.env.platform !== "notInDingTalk" ? true : false;
    },
  },
  mounted() {
    document.addEventListener("scroll", () => {
      if (document.documentElement.scrollTop > 60) {
        this.isTop = false;
      } else {
        this.isTop = true;
      }
    });
  },
};
</script>

<style scoped lang="less">
.header {
  height: 60px;
  padding: 0 120px;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.6);
  justify-content: space-between;
  transition: all 0.2s ease-in-out;
  @media (max-width: 1600px) {
    padding: 0 60px;
  }

  @media (max-width: 1400px) {
    padding: 0 20px;
  }

  &.header-fixed {
    background: #fff;
    box-shadow: 0px 2px 8px 0px rgba(16, 127, 255, 0.1);
  }
  .header-logo {
    display: flex;
    align-items: center;
    height: 100%;
    img {
      height: 30px;
      width: auto;
    }
  }
}

.header-nav {
  display: flex;
  align-items: center;
  gap: 40px;
  margin-left: 40px;
  height: 100%;
  line-height: 60px;
  .header-nav-item {
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 100%;
    gap: 4px;
    color: #1d2129;
    position: relative;
    .el-icon-arrow-down {
      font-size: 13px;
      transition: all 0.1s ease-in-out;
    }
    &:hover {
      .el-icon-arrow-down {
        transform: rotate(180deg);
      }
    }
    .header-nav-item-children {
      display: none;
      position: absolute;
      top: 50px;
      left: -20px;
      padding-top: 10px;
      z-index: 10;
      width: fit-content;
      .header-nav-item-box {
        box-shadow: 0px 6px 30px 0px rgba(0, 0, 0, 0.06);
        background: #ffffff;
        padding: 18px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: fit-content;
        .header-nav-item-box-item {
          color: #3d3d3d;
          font-size: 14px;
          line-height: 18px;
          gap: 8px;
          img {
            width: 24px;
            height: 24px;
          }
          &:hover {
            color: #2e98fe;
          }
        }
        .nav-header {
          display: flex;
          gap: 40px;
          padding-bottom: 12px;
          border-bottom: 1px solid #e5e7eb;
          width: 100%;
          .nav-header-item {
            line-height: 18px;
            font-size: 14px;
            color: #3d3d3d;
            &:hover {
              color: #2e98fe;
            }
            &.active {
              color: #2e98fe;
            }
          }
        }

        .nav-content {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 26px;
          padding-top: 26px;
          .nav-content-item {
            gap: 12px;
            width: 118px;
            justify-content: start;

            img {
              width: 30px;
              height: 30px;
            }
            span {
              font-size: 14px;
              color: #1d2129;
              line-height: 18px;
              &:hover {
                color: #2e98fe;
              }
            }
          }
        }
      }
    }
    &:hover {
      .header-nav-item-children {
        display: block;
      }
    }
  }
}

.header-btn {
  display: flex;
  align-items: center;
  gap: 16px;
  .header-btn-item {
    cursor: pointer;
    width: 108px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    font-size: 14px;
    background: linear-gradient(270deg, #48c2fd 0%, #2e98fe 100%);
    border-radius: 6px 6px 6px 6px;
    color: #ffffff;
    &.login {
      color: #2e98fe;
      background: #ffffff;
      border: 1px solid rgba(46, 152, 254, 0.2);
    }
  }
}
</style>